import { api } from './api';

interface DevflixAuthorizationResponse {
  redirectUrl: string;
  expiresIn: number;
}

export interface DevflixAuthorizationRequest {
  response_type: 'code';
  client_id: string;
  redirect_uri: string;
  state: string;
  nonce: string;
  code_challenge: string;
  code_challenge_method: 'S256';
  scope: string;
}

function unwrap<T>(value: T | { data: T }): T {
  return typeof value === 'object' && value !== null && 'data' in value
    ? value.data
    : value;
}

export const devflixService = {
  open(): void {
    const configured = import.meta.env.VITE_DEVFLIX_WEB_URL?.trim();
    if (!configured && import.meta.env.PROD) {
      throw new Error('DEVFLIX_WEB_URL_NOT_CONFIGURED');
    }
    const url = new URL(configured || 'http://localhost:3000');
    const local = ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname);
    if (
      url.username ||
      url.password ||
      url.search ||
      url.hash ||
      url.pathname !== '/' ||
      (url.protocol !== 'https:' && !(import.meta.env.DEV && local))
    ) {
      throw new Error('DEVFLIX_WEB_URL_INVALID');
    }
    window.location.assign(new URL('/sso/devclub/start', url).toString());
  },

  async authorize(input: DevflixAuthorizationRequest): Promise<string> {
    const response = await api.post<
      DevflixAuthorizationResponse | { data: DevflixAuthorizationResponse }
    >('/devflix-sso/authorize', input);
    return unwrap(response.data).redirectUrl;
  },
};
